"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reportingApi = exports.getEmotions = exports.getMvtReport = exports.getNpsCumulativeData = exports.getNpsFeedbacks = exports.getCampaignStatistics = exports.resetCampaignData = exports.getReadiness = exports.getVisitorAttributes = exports.getCities = exports.getRegions = exports.getCountries = exports.getTotalAmountOfVisitorsByCampaignIds = exports.getTotalAmountOfVisitors = exports.getAffiliationsForAccount = exports.getUsersAndSessions = exports.getTransactionProperties = exports.getFilteredData = exports.getCumulativeData = exports.getCombinedDataFeatureExp = exports.getCombinedData = void 0;
const createApi_1 = require("../../helpers/createApi");
const emotions_1 = require("./emotions");
const feedbackAnalysis_1 = require("./feedbackAnalysis");
const createCombinedDataGetter = (params = {}, headers = {}) => (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/combined`).get(params, headers);
};
exports.getCombinedData = createCombinedDataGetter();
exports.getCombinedDataFeatureExp = createCombinedDataGetter({}, { headers: { 'x-source': 'flagship' } });
const getCumulativeData = (caller) => ({ accountId, testId, start, end }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/cumulative`).get({ start, end });
};
exports.getCumulativeData = getCumulativeData;
const getFilteredData = (caller) => ({ accountId, testId, data }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting`).post(data);
};
exports.getFilteredData = getFilteredData;
const getTransactionProperties = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/transactionProperties`).get();
};
exports.getTransactionProperties = getTransactionProperties;
const getUsersAndSessions = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/sessions`).get();
};
exports.getUsersAndSessions = getUsersAndSessions;
const getAffiliationsForAccount = (caller) => ({ accountId }) => {
    return caller(`/clients/${accountId}/reporting/affiliations`).get();
};
exports.getAffiliationsForAccount = getAffiliationsForAccount;
const getTotalAmountOfVisitors = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/visitors`).get();
};
exports.getTotalAmountOfVisitors = getTotalAmountOfVisitors;
const getTotalAmountOfVisitorsByCampaignIds = (caller) => ({ accountId, campaignIds }) => {
    return caller(`/clients/${accountId}/visitor-count?campaignIDs=${campaignIds}`).get();
};
exports.getTotalAmountOfVisitorsByCampaignIds = getTotalAmountOfVisitorsByCampaignIds;
const getCountries = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/geo/country`).get();
};
exports.getCountries = getCountries;
const getRegions = (caller) => ({ accountId, testId, country }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/geo/region/${country}`).get();
};
exports.getRegions = getRegions;
const getCities = (caller) => ({ accountId, testId, country, region }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/geo/city/${country}/${region}`).get();
};
exports.getCities = getCities;
const getVisitorAttributes = (caller) => ({ accountId }) => {
    return caller(`/clients/${accountId}/visitorAttributes`).get();
};
exports.getVisitorAttributes = getVisitorAttributes;
const getReadiness = (caller) => ({ accountId, testId, goalId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reporting/${goalId}`).get();
};
exports.getReadiness = getReadiness;
const resetCampaignData = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/reset`).patch();
};
exports.resetCampaignData = resetCampaignData;
const getCampaignStatistics = (caller) => ({ accountId, testId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/stats`).get();
};
exports.getCampaignStatistics = getCampaignStatistics;
const getNpsFeedbacks = (caller) => ({ accountId, testId, query = {} }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/nps/feedbacks`).get(query);
};
exports.getNpsFeedbacks = getNpsFeedbacks;
const getNpsCumulativeData = (caller) => ({ accountId, testId, variationId }) => {
    return caller(`/clients/${accountId}/campaigns/${testId}/nps/cumulative/${variationId}`).get();
};
exports.getNpsCumulativeData = getNpsCumulativeData;
const getMvtReport = (caller) => ({ accountId, testId }) => {
    return caller(`clients/${accountId}/campaigns/${testId}/reporting/mvt_combined`).get();
};
exports.getMvtReport = getMvtReport;
const getEmotions = (caller) => ({ accountId, testId, emotion = 'combined' }) => {
    return caller(`clients/${accountId}/campaigns/${testId}/reporting/emotionsAI`).get({ emotion });
};
exports.getEmotions = getEmotions;
exports.reportingApi = (0, createApi_1.createAPIFactory)({
    getCombinedData: exports.getCombinedData,
    getCombinedDataFeatureExp: exports.getCombinedDataFeatureExp,
    getCumulativeData: exports.getCumulativeData,
    getFilteredData: exports.getFilteredData,
    getTransactionProperties: exports.getTransactionProperties,
    getUsersAndSessions: exports.getUsersAndSessions,
    getAffiliationsForAccount: exports.getAffiliationsForAccount,
    getTotalAmountOfVisitors: exports.getTotalAmountOfVisitors,
    getTotalAmountOfVisitorsByCampaignIds: exports.getTotalAmountOfVisitorsByCampaignIds,
    getVisitorAttributes: exports.getVisitorAttributes,
    getCountries: exports.getCountries,
    getRegions: exports.getRegions,
    getCities: exports.getCities,
    getReadiness: exports.getReadiness,
    resetCampaignData: exports.resetCampaignData,
    getCampaignStatistics: exports.getCampaignStatistics,
    getNpsFeedbacks: exports.getNpsFeedbacks,
    getNpsCumulativeData: exports.getNpsCumulativeData,
    getMvtReport: exports.getMvtReport,
    getEmotions: exports.getEmotions,
    emotions: emotions_1.emotions,
    feedbackAnalysis: feedbackAnalysis_1.feedbackAnalysis,
});
//# sourceMappingURL=api.js.map